import { Grid, Typography } from "@mui/material";

type Props = {
  label: string;
  children: React.ReactNode;
  labelVerticalAlign?: "top" | "center";
};

export const FilterItem = ({
  label,
  children,
  labelVerticalAlign = "center",
}: Props) => {
  return (
    <Grid item container spacing={2} xs={12} alignItems={labelVerticalAlign}>
      <Grid item xs={4}>
        <Typography color="textSecondary" align="right">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        {children}
      </Grid>
    </Grid>
  );
};
